export enum PatientAttachmentStatus {
  open = 'open',
  markedAsInvalid = 'marked_as_invalid',
  closed = 'closed',
}
